document.addEventListener("alpine:init", () => {
    Alpine.data("flyoutSearch", () => ({
        query: '',
        results: {
            page: [],
            post: [],
            project: [],
            event: [],
            species: [],
            water: [],
            region: [],
            district: [],
            association: []
        },
        hasPages: false,
        hasPosts: false,
        hasProjects: false,
        hasEvents: false,
        hasSpecies: false,
        hasWaters: false,
        hasRegions: false,
        hasDistricts: false,
        hasAssociations: false,
        loading: false,
        showResults: false,
        showNoResults: false,

        search() {
            if (this.query.trim().length < 2) {
                this.reset();
                return;
            }

            this.loading = true;

            fetch(flyoutSearchAjax.ajax_url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams({
                    action: 'flyout_search',
                    query: this.query.trim()
                })
            })
                .then(res => res.json())
                .then(data => {
                    this.loading = false;

                    this.results = {
                        page: data.page.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        post: data.post.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        project: data.project.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        event: data.event.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        species: data.species.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        water: data.water.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        region: data.region.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        district: data.district.map(item => ({
                            id: item.id,
                            title: item.title,
                            permalink: item.permalink
                        })),
                        association: data.association.map(item => ({
                            id: item.id,
                            title: item.title,
                            district_permalink: item.district_permalink
                        }))
                    };

                    this.hasPages = this.results.page.length > 0;
                    this.hasPosts = this.results.post.length > 0;
                    this.hasProjects = this.results.project.length > 0;
                    this.hasEvents = this.results.event.length > 0;
                    this.hasSpecies = this.results.species.length > 0;
                    this.hasWaters = this.results.water.length > 0;
                    this.hasRegions = this.results.region.length > 0;
                    this.hasDistricts = this.results.district.length > 0;
                    this.hasAssociations = this.results.association.length > 0;

                    if (this.hasPages || this.hasPosts || this.hasProjects || this.hasEvents || this.hasSpecies || this.hasWaters || this.hasRegions || this.hasDistricts || this.hasAssociations) {
                        this.showResults = true;
                        this.showNoResults = false;
                    } else {
                        this.showResults = false;
                        this.showNoResults = true;
                    }
                })
                .catch(err => {
                    console.error('Fetch error:', err);
                    this.loading = false;
                    this.reset();
                });
        },

        reset() {
            this.results = { page: [], post: [], project: [], event: [], species: [], water: [], region: [], district: [], association: [] };
            this.hasPages = this.hasPosts = this.hasProjects = this.hasEvents = this.hasSpecies = this.hasWaters = this.hasRegions = this.hasDistricts = this.hasAssociations = false;
            this.showResults = this.showNoResults = false;
        },

        clearSearch() {
            this.query = '';
            this.results = { page: [], post: [], project: [], event: [], species: [], water: [], region: [], district: [], association: [] };
            this.showResults = false;
            this.showNoResults = false;
            this.loading = false;
        }
    }));
});

//# sourceMappingURL=flyout-search.js.map
